import React from "react";

// Components
import Home from "components/Home/Home/Home";
import Footer from "components/Footer/Footer";

function HomePage() {
  return (
    <>
      <Home />
      <Footer />
    </>
  );
}

export default HomePage;
